module.exports = __webpack_public_path__ + "img/2900m.40faeec8.png";